import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useUserContext, hasPageAccess } from '../context/userContext';
import AIChatbotModule from '../pages/aiChatbot/AIChatbotModule';
import AIChatbotConfig from '../pages/aiChatbot/AIChatbotConfig';
import KnowledgeBase from '../pages/aiChatbot/KnowledgeBase';
import AIChatbotLogs from '../pages/aiChatbot/AIChatbotLogs';

const AIPageGuard = ({ pageKey, children }) => {
  const { userCtx } = useUserContext();
  if (!userCtx || !userCtx.pages || hasPageAccess(userCtx, pageKey)) return children;

  if (pageKey === 'knowledge_base' && hasPageAccess(userCtx, 'ai_chatbot')) {
    return <Navigate to="/dashboard/ai-chatbot" replace />;
  }

  if (hasPageAccess(userCtx, 'knowledge_base')) {
    return <Navigate to="/dashboard/ai-chatbot/knowledge-base" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

const AIChatbotRoute = () => (
  <Routes>
    <Route element={<AIChatbotModule />}>
      <Route index element={<AIPageGuard pageKey="ai_chatbot"><AIChatbotConfig /></AIPageGuard>} />
      <Route path="skills" element={<Navigate to="/dashboard/ai-chatbot/knowledge-base" replace />} />
      <Route path="knowledge-base" element={<AIPageGuard pageKey="knowledge_base"><KnowledgeBase /></AIPageGuard>} />
      <Route path="logs" element={<AIPageGuard pageKey="ai_chatbot"><AIChatbotLogs /></AIPageGuard>} />
      <Route path="*" element={<Navigate to="/dashboard/ai-chatbot" replace />} />
    </Route>
  </Routes>
);

export default AIChatbotRoute;
